export default "__VITE_ASSET__DtuHpErO__"